import * as tslib_1 from "tslib";
import { AppSelectorService } from '../app-selector/app-selector.service';
import { UserInfoService } from '../user-info/user-info.service';
import { DatacontextService } from 'src/app/data/datacontext.service';
import * as i0 from "@angular/core";
import * as i1 from "../app-selector/app-selector.service";
import * as i2 from "../user-info/user-info.service";
import * as i3 from "../../../data/datacontext.service";
var AmplitudeLoggerService = /** @class */ (function () {
    function AmplitudeLoggerService(appSelectorService, userInfo, datacontextService) {
        var _this = this;
        this.appSelectorService = appSelectorService;
        this.userInfo = userInfo;
        this.datacontextService = datacontextService;
        this.queuedLogs = [];
        Promise.all([
            this.userInfo.getUserData(),
            this.promisifyForCompanyDetails(),
        ]).then(function (data) {
            _this.userProps = data[0];
            _this.datacontextService.user.getUserCompany(function (resp) {
                _this.companyPlan = (resp && resp.api_response && resp.api_response.companies && resp.api_response.companies[0].plan) || '';
            });
            _this.companyDetails = _this.appSelectorService.getCompanyDetails();
        })
            .catch(function (error) {
            _this.userProps = error;
            _this.companyDetails = error;
        })
            .finally(function () {
            _this.initAmplitude();
            _this.executeQueuedLogs();
        });
    }
    AmplitudeLoggerService.prototype.promisifyForCompanyDetails = function () {
        var _this = this;
        //  Doing this weird hack to make sure we have the company details
        return new Promise(function (resolve, reject) {
            _this.appSelectorService.getAppListServiceReady().subscribe(function (data) { return data ? resolve(data) : reject({}); });
        });
    };
    AmplitudeLoggerService.prototype.initAmplitude = function () {
        amplitude.getInstance().setUserId(this.userProps.email || '');
        var identify = new amplitude.Identify().set('company', this.companyDetails.name || '')
            .set('company_id', this.companyDetails.id)
            .set('company_email', this.companyDetails.email)
            .set('user_email', this.userProps.email || '');
        amplitude.getInstance().identify(identify);
    };
    AmplitudeLoggerService.prototype.resetUser = function () {
        amplitude.getInstance().setUserId(null);
        amplitude.getInstance().regenerateDeviceId();
    };
    AmplitudeLoggerService.prototype.executeQueuedLogs = function () {
        for (var _i = 0, _a = this.queuedLogs; _i < _a.length; _i++) {
            var log = _a[_i];
            amplitude.getInstance().logEvent(log.eventName.toUpperCase(), log.mergedEventData);
            Hansel.logEvent(log.eventName, "amp", log.mergedEventData);
        }
        this.queuedLogs = null;
    };
    // TODO Make cta a part of eventData
    AmplitudeLoggerService.prototype.log = function (eventName, cta, eventData) {
        var globalMeta = {
            path: window.location.href,
            timestamp: new Date(),
            'app_id': this.appSelectorService.getSelectedApp().id || '',
            'account_type': this.companyPlan
        };
        var mergedEventData = tslib_1.__assign({}, globalMeta, eventData, { cta: cta });
        if (typeof this.userProps === 'undefined') {
            this.queuedLogs.push({ eventName: eventName, mergedEventData: mergedEventData });
            return;
        }
        amplitude.getInstance().logEvent(eventName.toUpperCase(), mergedEventData);
        Hansel.logEvent(eventName, "amp", mergedEventData);
    };
    AmplitudeLoggerService.ngInjectableDef = i0.defineInjectable({ factory: function AmplitudeLoggerService_Factory() { return new AmplitudeLoggerService(i0.inject(i1.AppSelectorService), i0.inject(i2.UserInfoService), i0.inject(i3.DatacontextService)); }, token: AmplitudeLoggerService, providedIn: "root" });
    return AmplitudeLoggerService;
}());
export { AmplitudeLoggerService };
